<!-- Modal (Pausar Chamadas) -->

<ng-template #pausarChamadas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pausar-chamadas"><b>Pausar Chamadas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-10">
        <label><b>Motivo:</b></label>

        <select class="form-control form-control-sm" name="motivoPausa" #motivoPausa (change)="selecionarMotivoPausa(motivoPausa.value)">
          @for (opcao of motivosPausa; track opcao) {
            <option [value]="opcao.id" [selected]="motivoPausaSelecionado != null ? opcao.id == motivoPausaSelecionado.id : null">{{ opcao.nome }}</option>
          }
        </select>

        @if (motivoPausaInvalido) {
          <div class="erro pt-1">Motivo inválido!</div>
        }
      </div>

      <div class="form-group col-sm-2">
        <label><b>Tempo:</b></label>

        <ngb-timepicker name="motivoPausaTempo" [spinners]="false" [(ngModel)]="motivoPausaTempo" disabled></ngb-timepicker>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Confirmar')">Confirmar</button>
  </div>
</ng-template>

@if (compacto) {
  <div class="discador_compacto">
    @if (discadorStatus == discadorStatusPause) {
      <button class="discador_compacto_botao discador_compacto_play" type="button" placement="left" ngbTooltip="Iniciar Chamadas" (click)="play()">
        <i class="fa fa-play"></i>
        <span class="discador_compacto_fallback">▶</span>
      </button>
    }

    @if (discadorStatus == discadorStatusPlay) {
      <button class="discador_compacto_botao discador_compacto_pause" type="button" placement="left" ngbTooltip="Pausar Chamadas" (click)="modalPausarChamadas(pausarChamadas)">
        <i class="fa fa-pause"></i>
      </button>
      <span class="discador_contador" title="Próxima chamada">{{ contadorCompacto }}</span>
    }

    @if (discador_pausado) {
      <button class="discador_compacto_botao discador_compacto_stop" type="button" placement="left" ngbTooltip="Cancelar Pausa" (click)="cancelarPausa()">
        <i class="fa fa-stop"></i>
      </button>
    }
  </div>
}

<div class="discador" [class.d-none]="compacto">
  <div class="d-flex align-items-center p-2">
    <!-- Mensagem -->

    <div class="flex-grow-1 text-center">
      <b>{{ discadorMensagem }}</b>
    </div>

    <!-- Ações -->

    @if (discadorStatus == discadorStatusPause) {
      <div class="p-2">
        <!-- Play -->
        <i class="fa fa-play discador_acoes discador_acoes_opcao" placement="left" ngbTooltip="Iniciar Chamadas" (click)="play()"></i>
      </div>
    }

    @if (discadorStatus == discadorStatusPlay) {
      <div class="p-2">
        <!-- Pause -->
        <i class="fa fa-pause discador_acoes discador_acoes_opcao" placement="left" ngbTooltip="Pausar Chamadas" (click)="modalPausarChamadas(pausarChamadas)"></i>
      </div>
    }

    @if (discador_pausado) {
      <div class="p-2">
        <!-- Cancelar Pausa -->
        <i class="fa fa-stop discador_acoes discador_acoes_opcao" placement="left" ngbTooltip="Cancelar Pausa" (click)="cancelarPausa()"></i>
      </div>
    }
  </div>
</div>

<hr class="mt-2 mb-2" [class.d-none]="compacto" />
